// @flow
import React, { ReactElement } from 'react'
import cx from 'classnames'
import type { IconType, ElementProps } from 'app/core/types'
import { getClassName } from './icons'

export type FontIconProps = {
  ...ElementProps,
  icon: IconType,
  className?: string,
}

export default function FontIcon(props: FontIconProps): ReactElement | null {
  const { icon, className, ...rest } = props
  return <div {...rest} className={cx('flex', className, getClassName(icon))} />
}
